import { combineReducers } from 'redux'

import { authReducer } from './auth/reducers'
import { blogReducer } from './blog/reducers'
import { categoryReducer } from './category/reducers'
import { companyReducer } from './company/reducers'
import { messageReducer } from './message/reducers'
import { productReducer } from './product/reducers'
import { settingReducer } from './setting/reducers'

export const rootReducer = combineReducers({
  auth: authReducer,
  blog: blogReducer,
  company: companyReducer,
  category: categoryReducer,
  product: productReducer,
  setting: settingReducer,
  message: messageReducer
})
